import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { useRouter } from 'next/router';
import LoginModal from 'src/components/LoginModal';
import useLogin from 'src/hooks/useLogin';
import { showModalAtom } from 'src/stores/modal/atoms';
import { EVENT_LOGIN_MODAL_VISITOR_TRIGGER } from 'src/types/Event';
import { ModalType } from 'src/types/Modal';
import { isStringInArray } from 'src/utils/common';
const useOpenLoginModalOnLandingPage = () => {
  const router = useRouter();
  const showModal = useSetAtom(showModalAtom);
  const {
    isLogin
  } = useLogin();
  useEffect(() => {
    if (router.isReady && !isLogin) {
      const {
        query
      } = router;
      const {
        trigger,
        landFrom
      } = query;
      if (isStringInArray(trigger, [EVENT_LOGIN_MODAL_VISITOR_TRIGGER.SEO_AZAR_LOGO, EVENT_LOGIN_MODAL_VISITOR_TRIGGER.SEO_START_VIDEO_CHAT]) && landFrom) {
        router.replace('/', undefined, {
          shallow: true
        }).then(() => showModal({
          key: ModalType.LOGIN,
          component: () => <LoginModal trigger={trigger} landFrom={landFrom as string} />
        }));
      }
    }
  }, [router, showModal, isLogin]);
};
export default useOpenLoginModalOnLandingPage;